import { Button, Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, RadioButtonGroup, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAccessAdmin extends Layout {
    DimsGid: Textbox;
    DimsName: Textbox;
    DimsRecid: Textbox;
    cbWfAliasGA: Checkbox;
    chkbCreateMonitors: Checkbox;
    chkbxNoDateExp: Checkbox;
    chkbxStatus: Checkbox;
    horizontalspacer1: HorizontalSpacer;
    labelAccessoints: Label;
    labelLabel1: Label;
    labelLabel2: Label;
    labelLabel3: Label;
    labelMCabinets: Label;
    lbl31: Label;
    lbl32: Label;
    lbl51: Label;
    lbl61: Label;
    lbl71: Label;
    lbl72: Label;
    lbl73: Label;
    lblAP: Label;
    lblAccessGA1: Label;
    lblAccessGA2: Label;
    lblAccessGA3: Label;
    lblApiDetailsRA: Label;
    lblApiFuncsRA: Label;
    lblAppsGA: Label;
    lblCatsGA: Label;
    lblDashboard: Label;
    lblDatabaseAlias: Label;
    lblDb2: Label;
    lblDb: Label;
    lblDbGA: Label;
    lblDbRA: Label;
    lblDbsWMA: Label;
    lblDeptsGA: Label;
    lblDocTypesGA: Label;
    lblGrGA: Label;
    lblGroupAccess: Label;
    lblGroups: Label;
    lblGroupsWMA: Label;
    lblModules: Label;
    lblModulesAccess: Label;
    lblProjectsRA: Label;
    lblQueuesGA: Label;
    lblRemoteBoxAccess: Label;
    lblRemoteBoxes: Label;
    lblRenditionAccess: Label;
    lblRestApiAccess: Label;
    lblRmb: Label;
    lblSA1: Label;
    lblSA2: Label;
    lblSA3: Label;
    lblSolutionsAccess: Label;
    lblTempAcc: Label;
    lblUsers1: Label;
    lblUsers2: Label;
    lblUsers: Label;
    lblUsersRA: Label;
    lblWebModuleAccess: Label;
    lblWebModulesWMA: Label;
    lblWorkflowAlias: Label;
    lbleFormsReports: Label;
    lbleFormsTemplates: Label;
    panelLeft: Panel;
    panelMain: Panel;
    panelTop: Panel;
    pbDisplayApiKey: Button;
    pnl1GA: Panel;
    pnl1RA: Panel;
    pnl1WMA: Panel;
    pnl2GA: Panel;
    pnl2WMA: Panel;
    pnl3GA: Panel;
    pnl3WMA: Panel;
    pnl4GA: Panel;
    pnl4WMA: Panel;
    pnl5GA: Panel;
    pnl62: Panel;
    pnl71: Panel;
    pnl72: Panel;
    pnl73: Panel;
    pnl74: Panel;
    pnlAccess: Panel;
    pnlAccessGA1: Panel;
    pnlAccessGA2: Panel;
    pnlAccessGA3: Panel;
    pnlCatsGA: Panel;
    pnlCold: Panel;
    pnlDbRA: Panel;
    pnlDeptsGA: Panel;
    pnlDocSec: Panel;
    pnlDocTypesGA: Panel;
    pnlGroups: Panel;
    pnlLeft2: Panel;
    pnlLeft3: Panel;
    pnlLeft51: Panel;
    pnlLeft: Panel;
    pnlMiddle2: Panel;
    pnlMiddle: Panel;
    pnlModules: Panel;
    pnlProjectsRA: Panel;
    pnlQueuesGA: Panel;
    pnlRight2: Panel;
    pnlRight3: Panel;
    pnlRight51: Panel;
    pnlRight: Panel;
    pnlSALeft: Panel;
    pnlSAMid: Panel;
    pnlSARight: Panel;
    pnlSATop: Panel;
    pnlTop1: Panel;
    pnlTop2: Panel;
    pnlTop3: Panel;
    pnlTop51: Panel;
    pnlTop: Panel;
    pnlUsersRA: Panel;
    pnlWorkflow: Panel;
    scanneridRG: RadioButtonGroup;
    sourceColdcat: DataSource;
    sourceColddep: DataSource;
    sourceDiaccess: DataSource;
    sourceDicatsec: DataSource;
    sourceDicoldusr: DataSource;
    sourceDidbalias: DataSource;
    sourceDigroup: DataSource;
    sourceDimodsec: DataSource;
    sourceDimodules: DataSource;
    sourceDirembox: DataSource;
    sourceDirenaccess: DataSource;
    sourceDiuser: DataSource;
    sourceDiwapisec: DataSource;
    sourceDiwfalias: DataSource;
    sourceDiwfuser: DataSource;
    sourceDiwmodsec: DataSource;
    sourceDminfo: DataSource;
    sourceDmsecurity: DataSource;
    sourceDstemplateh: DataSource;
    sourceDxaccessd: DataSource;
    sourceDxaccessh: DataSource;
    sourceDxaccgrnt: DataSource;
    sourceDxaccgrp: DataSource;
    sourceDxfunction: DataSource;
    sourceDxmasterp: DataSource;
    sourceDxproject: DataSource;
    sourceImagingMedia: DataSource;
    sourceImapCats: DataSource;
    sourceImgApps: DataSource;
    sourceImglistvalues: DataSource;
    sourceSecrembox: DataSource;
    sourceSectmplt: DataSource;
    sourceSecview: DataSource;
    sourceWfqueue: DataSource;
    tabDashboard: Tab;
    tabDatabaseAlias: Tab;
    tabGroupAccess: Tab;
    tabGroups: Tab;
    tabModuleAccess: Tab;
    tabModules: Tab;
    tabRemoteBoxAccess: Tab;
    tabRemoteBoxes: Tab;
    tabRenditionAccess: Tab;
    tabRestApiAccess: Tab;
    tabSolutionsAccess: Tab;
    tabUsers: Tab;
    tabWebModuleAccess: Tab;
    tabWorkflowAlias: Tab;
    tabeFormsReports: Tab;
    tabeFormsTemplates: Tab;
    tabsetAccessAdmin: Tabset;
    tbAccess: Tab;
    tbCold: Tab;
    tbDocSec: Tab;
    tbImapAppid: Textbox;
    tbWorkflow: Tab;
    tblAPSA: Table;
    tblATSA: Table;
    tblAccessGA: Table;
    tblApiFuncsRA: Table;
    tblAppsGA: Table;
    tblCatgsGA: Table;
    tblDatabaseAlias: Table;
    tblDb2: Table;
    tblDb8: Table;
    tblDbRA: Table;
    tblDbSA: Table;
    tblDbsGA: Table;
    tblDbsWMA: Table;
    tblDeptsGA: Table;
    tblDocTypesGA: Table;
    tblGroup: Table;
    tblGroups: Table;
    tblGroupsGA: Table;
    tblGroupsWMA: Table;
    tblMobAppsGA: Table;
    tblModSec: Table;
    tblModules: Table;
    tblMonitors: Table;
    tblProjectsRA: Table;
    tblRembox: Table;
    tblRenAccType9: Table;
    tblSolSA: Table;
    tblUsers1: Table;
    tblUsers2: Table;
    tblUsers3: Table;
    tblUsers4: Table;
    tblUsers5: Table;
    tblUsers7: Table;
    tblUsers: Table;
    tblUsersRA: Table;
    tblUsersSA: Table;
    tblVolIdGA: Table;
    tblWebModulesWMA: Table;
    tblWfqueueGA: Table;
    tblWorkflowAlias: Table;
    tbldidb: Table;
    tbldstemplateh: Table;
    tblsecrembox: Table;
    textboxDiaccessAppid: Textbox;
    textboxDiaccessDbalias: Textbox;
    textboxDiaccessEffvolid: Textbox;
    textboxDiaccessFilter: Textbox;
    textboxDiaccessFilterGA: Textbox;
    textboxDiaccessGid: Textbox;
    textboxDiaccessGrant: Textbox;
    textboxDiaccessScannerid: Textbox;
    textboxDiaccessWfalias: Textbox;
    textboxDicatsAppid: Textbox;
    textboxDicatsCatid: Textbox;
    textboxDicatsDbalias: Textbox;
    textboxDicatsGid: Textbox;
    textboxDicouCindex: Textbox;
    textboxDicouDbalias: Textbox;
    textboxDicouDindex: Textbox;
    textboxDicouGid: Textbox;
    textboxDiwAppName: Textbox;
    textboxDiwExpdate: Textbox;
    textboxDiwFuncId: Textbox;
    textboxDiwMasterId: Textbox;
    textboxDiwUid: Textbox;
    textboxDiwfaDesc: Textbox;
    textboxDiwfaWfaliasGA: Textbox;
    textboxDiwfusrQueueid: Textbox;
    textboxDiwfusrWfalias: Textbox;
    textboxDiwmsDba: Textbox;
    textboxDiwmsGid: Textbox;
    textboxDiwmsMpid: Textbox;
    textboxDmsecAccessMS: Textbox;
    textboxDmsecMidMS: Textbox;
    textboxDmsecUidMS: Textbox;
    textboxDxacdAccpnt: Textbox;
    textboxDxacdGrant: Textbox;
    textboxImapAppname: Textbox;
    textboxRenaccAccessRT: Textbox;
    textboxRenaccUidRT: Textbox;
    textboxSecvwUidVU: Textbox;
    textboxSecvwViewidVU: Textbox;
    textboxSrmbxRmbxidRA: Textbox;
    textboxSrmbxUseridRA: Textbox;
    textboxStmplTidTA: Textbox;
    textboxStmplUseridTA: Textbox;
    tsGroupAccess: Tabset;
}
